import React from "react";
import { ReactComponent as NetceteraLogoSvg } from "./assets/netcetera_logo.svg";
import styled from "@emotion/styled";

const NetceteraLogo = ({ className }: { className?: string }): JSX.Element => (
  <NetceteraLogoSvg className={className} />
);

export const StyledNetceteraLogo = styled(NetceteraLogo)`
  width: 160px;
`;
